import * as actionTypes from './constants';

const closeDialogToastAction = () => {
    return {
        type: actionTypes.CLOSE_DIALOG_TOAST
    };
};

export const closeDialogToast = () => {
    return (dispatch) => {
        dispatch(closeDialogToastAction());
    };
};
